import {Popover, PopoverAnchor, PopoverContent} from '@/shadcn_components/ui/popover';
import {Separator} from '@/shadcn_components/ui/separator';
import useDialogState, {UseDialogStateReturn} from '@/hooks/useDialogState';
import {ReactNode, useRef, useState} from 'react';
import useClickOutside from '@/hooks/useClickOutside';
import Draggable from 'react-draggable';

interface IAnchor {
  x: number; //client x
  y: number; //client y
  nodeX: number;
  nodeY: number;
}

export type ContextMenuItem = {
  id: string;
  label: string;
  onClick?: (self: ContextMenuItem) => void;
};

/**
 * Hook
 */
export type UsePopoverContextMenuReturn = {
  state: UseDialogStateReturn;
  anchor?: IAnchor;
  setAnchor: React.Dispatch<React.SetStateAction<IAnchor | undefined>>;
  onContextMenu: (event, extraData?: any) => void; //when UI right click
};

export function usePopoverContextMenu(): UsePopoverContextMenuReturn {
  const state = useDialogState();
  const [anchor, setAnchor] = useState<IAnchor>();

  function onContextMenu(e, extraData?: any) {
    e.preventDefault();
    e.stopPropagation();
    const rect = e.target.getBoundingClientRect();
    setAnchor({
      x: e.clientX,
      y: e.clientY,
      nodeX: e.clientX - rect.left,
      nodeY: e.clientY - rect.top,
    });

    state.openDialog(extraData);
  }

  return {state, anchor, setAnchor, onContextMenu};
}

/**
 * Components
 */
export const PopoverContextMenu = ({
  menuItems,
  title,
  ...popoverContextMenu
}: {
  menuItems: ContextMenuItem[];
  title: string;
} & UsePopoverContextMenuReturn) => {
  const {state, anchor} = popoverContextMenu;

  const refCtxMenu = useRef<any>();
  useClickOutside(refCtxMenu, () => {
    setTimeout(state.closeDialog, 0);
  });

  return (
    <Popover open={state.open} onOpenChange={state.openDialog} modal>
      <PopoverAnchor
        className="fixed text-transparent"
        style={{left: anchor?.x || 0, top: anchor?.y || 0}}>
        X
      </PopoverAnchor>
      {/* @ts-ignore */}
      <PopoverContent side="right" className="text-sm" ref={refCtxMenu}>
        {title && <p className="mb-2 font-semibold">{title}</p>}
        {title && <Separator className="my-2" />}
        {menuItems.map((m, i) => (
          <div
            key={m.id}
            className="hover:bg-primary hover:text-primary-foreground p-2 rounded-md cursor-pointer"
            onClick={() => {
              m.onClick?.(m);
              state.closeDialog();
            }}
            onContextMenu={e => {
              e.preventDefault();
              e.stopPropagation();
            }}>
            {/* {m.icon} */}
            <span>{m.label}</span>
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
};

export const PopoverWithAnchor = (props: UsePopoverContextMenuReturn & {children: ReactNode}) => {
  const {state, anchor, children} = props;

  const refCtxMenu = useRef<any>();
  useClickOutside(refCtxMenu, () => {
    setTimeout(state.closeDialog, 0);
  });

  return (
    <Popover open={state.open} onOpenChange={state.openDialog} modal>
      <PopoverAnchor
        className="fixed text-transparent"
        style={{left: anchor?.x || 0, top: anchor?.y || 0}}>
        X
      </PopoverAnchor>
      {/* @ts-ignore */}
      <Draggable handle=".draggable-handle">
        <PopoverContent side="right" className="text-sm" ref={refCtxMenu}>
          <div>{children}</div>
        </PopoverContent>
      </Draggable>
    </Popover>
  );
};
